import { MapPin, Mail, Phone } from "lucide-react";
import { Logo } from "./Logo";

export const Footer = () => (
  <footer id="contact" data-testid="footer-section" className="bg-ink text-white overflow-hidden">
    <div className="max-w-7xl mx-auto px-6 lg:px-12 pt-24 lg:pt-32 pb-12">
      <div className="grid lg:grid-cols-12 gap-14 mb-24">
        <div className="lg:col-span-5">
          <Logo light />
          <p className="mt-8 text-white/60 text-base leading-relaxed max-w-sm">
            Patient-centred, evidence-based physiotherapy in Plumstead, Cape Town.
            Empowering people through movement.
          </p>
        </div>
        <div className="lg:col-span-4">
          <h3 className="text-xs font-bold tracking-[0.3em] uppercase text-electric mb-8">Contact Us</h3>
          <ul className="space-y-6 text-white/80 text-base">
            <li className="flex items-start gap-4" data-testid="contact-address">
              <MapPin size={20} className="text-electric shrink-0 mt-0.5" />
              <span>58 Dick Burton Street,<br />Plumstead, Cape Town,<br />Western Cape</span>
            </li>
            <li data-testid="contact-email">
              <a href="mailto:fivepointphysiotherapy@gmail.com" className="flex items-center gap-4 hover:text-electric transition-colors duration-200">
                <Mail size={20} className="text-electric shrink-0" />
                fivepointphysiotherapy@gmail.com
              </a>
            </li>
            <li data-testid="contact-phone">
              <a href="tel:+27213965530" className="flex items-center gap-4 hover:text-electric transition-colors duration-200">
                <Phone size={20} className="text-electric shrink-0" />
                021 396 5530
              </a>
            </li>
          </ul>
        </div>
        <div className="lg:col-span-3">
          <h3 className="text-xs font-bold tracking-[0.3em] uppercase text-electric mb-8">Explore</h3>
          <ul className="space-y-4 text-white/70 text-sm">
            {[["About", "#about"], ["Services", "#services"], ["Team", "#team"], ["Reviews", "#reviews"], ["Book Appointment", "#book"]].map(([label, href]) => (
              <li key={href}>
                <a href={href} data-testid={`footer-${label.toLowerCase().replace(/\s+/g, "-")}-link`} className="hover:text-electric transition-colors duration-200">
                  {label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="select-none pointer-events-none text-center" aria-hidden="true">
        <span className="font-display font-black tracking-tighter leading-none text-[16.5vw] text-outline-light whitespace-nowrap">
          FIVEPOINT
        </span>
      </div>

      <div className="mt-10 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-white/40">
        <p>© {new Date().getFullYear()} FivePoint Physiotherapy. All rights reserved.</p>
        <p>Medical aid · Cash & card accepted · Itemised invoices</p>
        <p>HPCSA-registered practice · POPIA compliant · Plumstead, Cape Town</p>
      </div>
    </div>
  </footer>
);
